import React, { Component, Fragment } from 'react';
import UserService from '../Services/UserService.js';
import AdminService from '../Services/AdminService.js';
import UsersList from '../Components/Users/UsersList.js';
import UsersCreator from '../Components/Users/UsersCreator.js';
import { withApi } from '../Providers/WebServiceProvider.js';

class EditUsers extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			users: [],
			tokens: [],
			isLoaded: false
		}

		this.userService = new UserService(props.webServiceContext.getApi());
		this.adminService = new AdminService(props.webServiceContext.getApi());
	}

	userCreator = (firstname, lastname, email) => {
		const that = this;

		return this.adminService.inviteUser(firstname, lastname, email)
			.then(function (user) {
				that.setState((prevState) => ({ users: prevState.users.concat([user]) }));
			});
	}

	loadServerTokens () {
		const that = this;

		this.adminService.listTokens().then((tokens) => { that.setState({ tokens: tokens }); });
	}

	load () {
		const that = this;

		this.userService.list()
			.then(function (users) {
				that.setState({ users: users, isLoaded: true });
			})
			.catch(function (users) {
				that.setState({ users: users, isLoaded: true });
			});
	}

	componentDidMount () {
		this.load();
		this.loadServerTokens();
	}

	render () {
		const that = this;

		if (this.state.isLoaded) {
			return (
				<Fragment>
					<div className="section">
		 	  		<UsersCreator creator={this.userCreator} />
		 	  		<div className="column is-8 is-offset-2">
			 	  		<UsersList
			 	  			serverTokens={this.state.tokens}
			 	  			deleter={this.userService.delete}
			 	  			enabler={this.userService.undelete}
			 	  			updater={this.userService.update}
			 	  			users={this.state.users}
			 	  		/>
		 	  		</div>
		 	  	</div>
	 	  	</Fragment>
			);
		} else {
			return ('Loading...');
		}
	}
}

export default withApi(EditUsers);



// WEBPACK FOOTER //
// ./src/Pages/EditUsers.js